import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Ort } from '../../model/ort';
import { OrtClient } from '../integration/ort.client';

/**
 * Unterstützt bei der Bestimmung des Standorts.
 */
@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  private readonly ortClient = inject(OrtClient);

  /**
   * Fragt den Nutzer nach seinem Standort und wandelt die Koordinaten
   * mittels Backendaufruf in ein Ortsobjekt um.
   */
  public async loadCurrentPosition(): Promise<Ort> {
    const { coords } = await this.getCurrentPosition();
    return firstValueFrom(this.ortClient.getOrtByCoords(coords.latitude, coords.longitude));
  }

  /**
   * Wickelt die Browser-API zur Abfrage des Standortes in ein Promise.
   */
  private getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    );
  }
}
